export default __webpack_public_path__ + "static/media/MY.2e53003f.ico";